import { render, staticRenderFns } from "./ResendVerificationIndex.vue?vue&type=template&id=1226c88b&"
import script from "./ResendVerificationIndex.vue?vue&type=script&lang=js&"
export * from "./ResendVerificationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports